<template>
  <AppLayout>
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">
        <div class="widget-heading">
          <div class="row">
            <div class="col-12 d-inline-flex align-items-center">
              <h4 class="me-3 my-0">Powiadomienia / Alarmy</h4>
              <button @click="openModal" class="btn btn-primary btn-sm">
                <i class="bi bi-plus-circle me-2"></i>
                Dodaj
              </button>
            </div>
          </div>
        </div>
        <div class="widget-content">
          <div class="custom-table">
            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Tytuł</th>
                    <th>Utworzył</th>
                    <th>Status</th>
                    <th>Wysłano do</th>
                    <th>Opcje</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(rcb, index) in rcbLocal" :key="rcb.id ?? index">
                    <td>{{ rcb.id }}</td>
                    <td>
                      {{ rcb.title }}<br>

                      <span class="badge mb-2" :class="badgeClass(rcb.type)">
                        {{ typeLabel(rcb.type) }}
                      </span>
                    </td>
                    <td>
                      {{ rcb.creator?.name || '' }}<br>
                      {{ formatDate(rcb.created_at) }}
                    </td>
                    <td>
                      {{
                        rcb.active == 1
                          ? 'Aktywne'
                          : 'Zarchiwizowane'
                      }}
                    </td>
                    <td>
                      <span v-if="
                        rcb.send_to !== null &&
                        rcb.send_to !== undefined
                      " class="badge bg-success">
                        {{ rcb.send_to }}
                      </span>
                      <span v-else class="badge bg-secondary">
                        Nie wysłano
                      </span>
                    </td>
                    <td>
                      <button v-if="rcb.active == 1" @click="sendtest(rcb)"
                        class="btn btn-sm btn-outline-primary me-2 mb-2">
                        <i class="bi bi-envelope me-2"></i>
                        Wyślij do siebie
                      </button>
                      <button v-if="rcb.active == 1" @click="sendRCB(rcb)"
                        class="btn btn-sm btn-outline-success me-2 mb-2">
                        <i class="bi bi-envelope me-2"></i>
                        Wyślij
                      </button>
                      <button @click="editRCB(rcb)" class="btn btn-sm btn-outline-info me-2 mb-2">
                        <i class="bi bi-pencil me-2"></i>
                        Edytuj
                      </button>
                      <button @click="deleteRCB(rcb.id)" class="btn btn-sm btn-danger me-2 mb-2">
                        <i class="bi bi-trash me-2"></i>
                        Usuń
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-if="isModalOpen" class="modal fade show" tabindex="-1" style="display: block;">
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">
                    Nowa informacja
                  </h5>
                  <button type="button" class="btn-close" @click="closeModal"></button>
                </div>
                <div class="modal-body">
                  <div class="row">
                    <div class="col-md-6">
                      <label class="form-label" for="newTitle">
                        Tytuł wiadomości:
                      </label>

                      <input id="newTitle" v-model="newRCB.title" class="form-control" />
                    </div>
                    <div class="col-md-12">
                      <HtmlOrRichTextEditor class="mt-2" id="editorDescription" label="Treść wiadomości"
                        modelName="description" v-model="newRCB.description" />
                    </div>
                    <div class="col-md-6">
                      <label class="form-label" for="newType">
                        Rodzaj informacji:
                      </label>
                      <select id="newType" v-model="newRCB.type" class="form-select">
                        <option :value="1">
                          Informacja
                        </option>

                        <option :value="2">
                          Nowe zagrożenie
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-danger" @click="closeModal">
                    Anuluj
                  </button>

                  <button class="btn btn-primary" @click="saveNewRCB">
                    Zapisz
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div v-if="isEditModalOpen" class="modal fade show" tabindex="-1" style="display: block;">
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">
                    Edycja informacji
                  </h5>
                  <button type="button" class="btn-close" @click="closeEditModal"></button>
                </div>
                <div class="modal-body">
                  <div class="row">
                    <div class="col-md-6">
                      <label class="form-label" for="editTitle">
                        Tytuł wiadomości:
                      </label>
                      <input id="editTitle" v-model="editedRCB.title" class="form-control" />
                    </div>
                    <div class="col-md-12">
                      <HtmlOrRichTextEditor class="mt-2" id="editorDescriptionEdit" label="Treść wiadomości"
                        modelName="description" v-model="editedRCB.description" />
                    </div>
                    <div class="col-md-6">
                      <label class="form-label" for="editType">
                        Rodzaj informacji:
                      </label>
                      <select id="editType" v-model="editedRCB.type" class="form-select">
                        <option :value="1">
                          Informacja
                        </option>
                        <option :value="2">
                          Nowe zagrożenie
                        </option>
                      </select>
                    </div>
                    <div class="col-md-6">
                      <label class="form-label" for="active">
                        Status:
                      </label>

                      <select id="active" v-model="editedRCB.active" class="form-select">
                        <option :value="0">
                          Zarchiwizowana
                        </option>

                        <option :value="1">
                          Aktywna
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-danger" @click="closeEditModal">
                    Anuluj
                  </button>
                  <button class="btn btn-primary" @click="updateRCB(editedRCB)">
                    Zapisz
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div v-if="isSendUsersModalOpen" class="modal fade show" tabindex="-1" style="
                            display: block;
                            background: rgba(0, 0, 0, 0.5);
                        ">
            <div class="modal-dialog modal-lg modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-header">
                  <div>
                    <h5 class="modal-title mb-1">
                      Wybierz odbiorców
                    </h5>
                    <small v-if="selectedRCB" class="text-muted">
                      {{ selectedRCB.title }}
                    </small>
                  </div>
                  <button type="button" class="btn-close" @click="closeSendUsersModal"></button>
                </div>

                <div class="modal-body">
                  <div class="d-flex justify-content-between align-items-center mb-3">
                    <div>
                      <strong>
                        Wybrano:
                        {{ selectedUsers.length }}
                      </strong>

                      /
                      {{ users.length }}
                    </div>
                    <button type="button" class="btn btn-sm btn-outline-secondary" @click="toggleSelectAllUsers">
                      {{
                        selectAllUsers
                          ? 'Odznacz wszystkich'
                          : 'Zaznacz wszystkich'
                      }}
                    </button>
                  </div>
                  <div class="select-all-wrapper mb-3 p-3 border rounded">
                    <label for="toggleAll" class="d-flex align-items-center gap-2" style="cursor: pointer;">
                      <input id="toggleAll" type="checkbox" class="user-checkbox" v-model="selectAllUsers"
                        @change="toggleSelectAllUsers" />

                      <span>
                        Zaznacz wszystkich
                      </span>
                    </label>
                  </div>
                  <div class="table-responsive" style="
                                            max-height: 450px;
                                            overflow-y: auto;
                                        ">
                    <table class="table table-hover table-bordered align-middle">
                      <thead>
                        <tr>
                          <th style="width: 50px;"></th>
                          <th>Nazwisko</th>
                          <th>Imię</th>
                          <th>Email</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="user in sortedUsers" :key="user.id" @click="
                          toggleUser(user.id)
                          " style="cursor: pointer;">
                          <td>
                            <input type="checkbox" class="user-checkbox" :checked="selectedUsers.includes(
                              user.id
                            )
                              " @click.stop @change="
                                                              toggleUser(
                                                                user.id
                                                              )
                                                              " />
                          </td>
                          <td>
                            {{ user.last_name }}
                          </td>
                          <td>
                            {{ user.first_name }}
                          </td>
                          <td>
                            {{ user.email }}
                          </td>
                        </tr>
                        <tr v-if="users.length === 0">
                          <td colspan="4" class="text-center text-muted py-4">
                            Brak użytkowników do
                            wysłania.
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="modal-footer">
                  <button type="button" class="btn btn-danger" @click="closeSendUsersModal">
                    Anuluj
                  </button>
                  <button type="button" class="btn btn-success" :disabled="selectedUsers.length === 0 ||
                    isSending
                    " @click="confirmSendRCB">
                    <i v-if="!isSending" class="bi bi-envelope me-2"></i>
                    <span v-if="isSending" class="spinner-border spinner-border-sm me-2"></span>
                    {{
                      isSending
                        ? 'Wysyłanie...'
                        : `Wyślij do ${selectedUsers.length} osób`
                    }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import {
  usePermission
} from "@/composables/resources/js/composables/permissions.js";
import HtmlOrRichTextEditor from "@/Pages/Admin/parts/HtmlOrRichTextEditor.vue";

const { hasPermission } = usePermission();

export default {
  components: {
    AppLayout,
    HtmlOrRichTextEditor
  },

  props: {
    rcb: {
      type: Array,
      default: () => []
    },
    users: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      hasPermission,
      editingId: null,
      addingNew: false,
      newRCB: this.getEmptyForm(),
      editedRCB: {},
      rcbLocal: [],
      isModalOpen: false,
      isEditModalOpen: false,
      selectedRCB: null,
      selectedUsers: [],
      selectAllUsers: false,
      isSendUsersModalOpen: false,
      isSending: false
    };
  },
  computed: {
    sortedUsers() {
      return [...this.users].sort((a, b) => {
        const nazwiskoA = (
          a.last_name || ''
        ).toLowerCase();

        const nazwiskoB = (
          b.last_name || ''
        ).toLowerCase();

        return nazwiskoA.localeCompare(
          nazwiskoB,
          'pl'
        );
      });
    }
  },
  mounted() {
    this.rcbLocal = this.rcb.map(item => ({
      ...item
    }));
  },
  methods: {
    toggleSelectAllUsers() {
      if (this.selectAllUsers) {
        this.selectedUsers = this.users.map(
          user => user.id
        );
      } else {
        this.selectedUsers = [];
      }
    },
    toggleUser(userId) {
      if (this.selectedUsers.includes(userId)) {
        this.selectedUsers =
          this.selectedUsers.filter(
            id => id !== userId
          );
      } else {
        this.selectedUsers.push(userId);
      }

      this.selectAllUsers =
        this.users.length > 0 &&
        this.selectedUsers.length === this.users.length;
    },
    sendRCB(rcb) {
      this.selectedRCB = rcb;
      this.selectedUsers = [];
      this.selectAllUsers = false;
      this.isSendUsersModalOpen = true;
    },
    closeSendUsersModal() {
      this.isSendUsersModalOpen = false;
      this.selectedRCB = null;
      this.selectedUsers = [];
      this.selectAllUsers = false;
      this.isSending = false;
    },
    confirmSendRCB() {
      if (
        !this.selectedRCB ||
        this.selectedUsers.length === 0
      ) {
        return;
      }
      const rcb = this.selectedRCB;
      const userIds = [
        ...this.selectedUsers
      ];
      this.isSending = true;
      this.$inertia.post(
        route(
          'admin.rcb.send-mail',
          rcb.id
        ),
        {
          user_ids: userIds
        },
        {
          preserveScroll: true,
          onSuccess: () => {
            this.isSending = false;
            this.closeSendUsersModal();
            Toast.fire({
              toast: true,
              icon: 'success',
              title: 'Wysyłanie zakończone',
              html:
                `Wiadomość została wysłana do ${userIds.length} osób.`,
              position: 'top-end',
              timer: 4000,
              showConfirmButton: false
            });
            this.$inertia.reload({
              only: ['rcb'],
              preserveScroll: true,
              onSuccess: page => {
                this.rcbLocal =
                  page.props.rcb.map(
                    item => ({
                      ...item
                    })
                  );
              }
            });
          },
          onError: () => {
            this.isSending = false;
            Toast.fire({
              toast: true,
              icon: 'error',
              title: 'Błąd wysyłania',
              html:
                'Nie udało się wysłać wiadomości.',
              position: 'top-end',
              timer: 4000,
              showConfirmButton: false
            });
          }
        }
      );
    },
    sendtest(rcb) {
      Toast.fire({
        toast: false,
        icon: 'question',
        title: 'Wysyłanie testowe',
        html: `
                    <div style="text-align: center;">
                        <p style="margin-bottom: 10px;">
                            Czy chcesz wysłać to ogłoszenie
                            <strong>na swój adres e-mail?</strong>
                        </p>

                        <div style="
                            background: #f8f9fa;
                            padding: 10px;
                            border-radius: 5px;
                            text-align: left;
                            margin-top: 10px;
                        ">
                            <strong>${rcb.title}</strong>
                        </div>
                    </div>
                `,

        showDenyButton: true,
        showConfirmButton: true,

        confirmButtonText: 'Tak, wyślij',
        denyButtonText: 'Anuluj',

        timer: false,
        position: 'center'
      }).then(result => {
        if (!result.isConfirmed) {
          return;
        }

        this.$inertia.post(
          route(
            'admin.rcb.send-test-mail',
            rcb.id
          ),
          {},
          {
            preserveScroll: true,
            onSuccess: () => {
              Toast.fire({
                toast: true,
                icon: 'success',
                title: 'Wysłano',
                html:
                  'Wiadomość została wysłana na Twój adres e-mail.',
                position: 'top-end',
                timer: 4000,
                showConfirmButton: false
              });
            },
            onError: () => {
              Toast.fire({
                toast: true,
                icon: 'error',
                title: 'Błąd wysyłania',
                html:
                  'Nie udało się wysłać wiadomości.',
                position: 'top-end',
                timer: 4000,
                showConfirmButton: false
              });
            }
          }
        );
      });
    },
    openModal() {
      this.newRCB = this.getEmptyForm();

      this.isModalOpen = true;
    },

    closeModal() {
      this.isModalOpen = false;

      this.newRCB = this.getEmptyForm();
    },

    getEmptyForm() {
      return {
        id: null,
        title: '',
        description:
          '<pre><span style="font-size: 10pt; font-family: arimo, helvetica, sans-serif;">Wstaw tu treść informacji</span></pre>',
        type: 1,
        mailto: '',
        active: null
      };
    },

    addRCB() {
      this.addingNew = true;
      this.newRCB = this.getEmptyForm();
    },

    cancelNewRCB() {
      this.addingNew = false;
      this.newRCB = this.getEmptyForm();
    },

    saveNewRCB() {
      const payload = {
        ...this.newRCB,
        description:
          typeof this.newRCB.description === 'object'
            ? this.newRCB.description.value
            : this.newRCB.description
      };
      this.$inertia.post(
        route('admin.rcb.dodaj'),
        payload,
        {
          onSuccess: () => {
            this.newRCB =
              this.getEmptyForm();
            this.isModalOpen = false;
            this.rcbLocal =
              this.rcb.map(
                item => ({
                  ...item
                })
              );
          }
        }
      );
    },
    editRCB(rcb) {
      this.editingId = rcb.id;
      this.editedRCB = {
        ...rcb
      };
      this.isEditModalOpen = true;
    },

    closeEditModal() {
      this.isEditModalOpen = false;
      this.editedRCB = {};
    },

    updateRCB(rcb) {
      const payload = {
        ...rcb,
        description:
          typeof rcb.description === 'object'
            ? rcb.description.value
            : rcb.description
      };

      this.$inertia.put(
        route(
          'admin.rcb.update',
          rcb.id
        ),
        payload,
        {
          onSuccess: () => {
            const idx =
              this.rcbLocal.findIndex(
                item =>
                  item.id === rcb.id
              );

            if (idx !== -1) {
              this.rcbLocal[idx] = {
                ...payload
              };
            }

            this.isEditModalOpen =
              false;
          }
        }
      );
    },
    deleteRCB(id) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie informacji',
        html:
          'Czy na pewno chcesz usunąć wybraną informację?',
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
        timer: false,
        position: 'center'
      }).then(result => {
        if (!result.isConfirmed) {
          return;
        }
        this.$inertia.delete(
          route(
            'admin.rcb.usun',
            id
          ),
          {
            onSuccess: () => {
              this.rcbLocal =
                this.rcbLocal.filter(
                  item =>
                    item.id !== id
                );
            }
          }
        );
      });
    },

    formatDate(timestamp) {
      if (!timestamp) {
        return '';
      }

      const date = new Date(timestamp);

      return date
        .toISOString()
        .split('T')[0];
    },

    typeLabel(type) {
      return {
        1: 'Informacja',
        2: 'Nowe zagrożenie'
      }[type] || 'Informacja';
    },

    badgeClass(type) {
      return {
        1: 'bg-primary',
        2: 'bg-danger'
      }[type] || 'bg-primary';
    }
  }
};
</script>
<style>
.select-all-wrapper {
  display: flex;
  align-items: center;
}

.select-all-label {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 0;
  cursor: pointer;
  font-weight: 600;
}

.user-checkbox {
  appearance: none;
  -webkit-appearance: none;

  width: 20px !important;
  height: 20px !important;

  border: 2px solid #999;
  border-radius: 5px;

  cursor: pointer;
  display: inline-block;
  vertical-align: middle;
  margin: 0;
}

.user-checkbox:checked {
  background-color: #198754;
  border-color: #198754;
  position: relative;
}

.user-checkbox:checked::after {
  content: "✓";
  color: white;
  font-size: 19px;
  font-weight: bold;

  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -55%);
}
</style>
